import checkEmail from "./check-email.js";

const sendNewsletterForm = () => {
  const forms = document.querySelectorAll("form.newsletter-subscribe-form");

  forms.forEach((form) => {
    const formSubtitle = document.querySelector(".form-subtitle");
    const submitBtn = form.querySelector(".submit-newsletter-form-btn");
    const statusInfoBlock = form.querySelector(".error-msg");
    const emailInput = form.querySelector('input[name="email"]');

    const message = {
      loading: themeUrl.loading,
      success: themeUrl.success_newsletter,
      failure: themeUrl.failure,
    };

    const clearInputs = () => {
      form.reset();
    };

    emailInput.addEventListener("change", () => {
      if (emailInput.classList.contains("error")) {
        emailInput.classList.remove("error");
        statusInfoBlock.classList.remove("field-error");
        statusInfoBlock.textContent = "";
        statusInfoBlock.classList.remove("show");
      }
    });

    function emailValue() {
      return checkEmail(emailInput, statusInfoBlock);
    }

    const validateForm = () => {
      if (!emailValue()) {
        return false;
      }
      return true;
    };

    const postData = async (url, data) => {
      statusInfoBlock.textContent = message.loading;

      const res = await fetch(url, {
        method: "POST",
        body: data,
      });

      const text = await res.text();

      if (!res.ok) {
        throw new Error(`Server returned status ${res.status}: ${text}`);
      }

      return text;
    };

    form.addEventListener("submit", (e) => {
      e.preventDefault();
      console.log("submited");

      if (!validateForm()) {
        console.log("validation failed");
        return false;
      }

      let formData = new FormData(form);
      formData.append("action", "send_newsletter_form");

      postData(themeUrl.ajax_url, formData)
        .then((res) => {
          if (res) {
            console.log("success response");
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
              event: "form_submission",
            });
            // Hide input, button, and subtitle on success
            emailInput.style.display = "none";
            submitBtn.style.display = "none";
            if (formSubtitle) {
              formSubtitle.style.display = "none";
            }

            statusInfoBlock.classList.add("green");
            statusInfoBlock.textContent = message.success;
          }
        })
        .catch(() => {
          console.log("error response");
          statusInfoBlock.classList.remove("green");
          statusInfoBlock.textContent = message.failure;
        })
        .finally(() => {
          console.log("finally");
          clearInputs();
          setTimeout(() => {}, 5000);
        });
    });
  });
};

export default sendNewsletterForm;
